import React from "react";
import { useTranslation } from "react-i18next";
import U2000ActionBtn from "../../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { NS, U3139ROLES } from "../../../U3139";
import { FaPlus, FaRegFile, FaTrashAlt } from "react-icons/fa";
import { useU2000AuthContext } from "../../../../u2000Core/context/auth/U2000UseAuthContext";
import { U2000FormStateEnumState } from "../../../../u2000Core/reducer/formReducer/U2000FormState";
import type { U3139MinutesFormExtendedHandlers } from "./u3139DetailLotsTab/U3139DetailLotsBody";

interface U3139MinutesFormToolBarProps {
  formStateHandlers: U3139MinutesFormExtendedHandlers;
}

export const U3139MinutesFormToolBar: React.FC<U3139MinutesFormToolBarProps> = ({ formStateHandlers }) => {
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();
  const formState = formStateHandlers.getFormState();

  const actions = [
    {
      key: "add",
      label: t("btnAdd", { ns: NS }),
      hasRole: hasRole(U3139ROLES.ADD),
      handleClick: () => formStateHandlers.addNewMinute?.(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: "modify",
      label: t("btnModify", { ns: NS }),
      hasRole: hasRole(U3139ROLES.EDIT),
      handleClick: () => formStateHandlers.modifyMinute?.(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: "delete",
      label: t("btnDelete", { ns: NS }),
      hasRole: hasRole(U3139ROLES.DELETE),
      handleClick: () => formStateHandlers.deleteMinute?.(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
